export default "__VITE_ASSET__BT2Jpg$N__"